import { PJAxios, useLanguage, sendLogin, usePJStore, useUserInfo } from '@jaf/jaf-react-core';
import axios from 'axios';
import moment from 'moment/moment';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Chip } from 'primereact/chip';
import React, { use, useEffect, useMemo, useRef, useState } from 'react';
import { Buffer } from 'buffer';
import '../ChatbotRestyled.css';
import { sha256 } from 'js-sha256';
import { PJButton } from '@it-polimi/pj-react-ui';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useHistory } from 'react-router-dom';
import { useStore } from '../../../store/store';



function ContactChannels(props) {

    const getText = usePJStore((state) => state.i18n_getText)
    const { storage } = usePJStore((state) => state.storage)
    const language = useLanguage();
    const isLogged = useUserInfo() != null;
    const history = useHistory();

    const userInfo = useUserInfo();

    const [dialogVisible, setDialogVisible] = useState(false)
    const [sideraDialogVisible, setSideraDialogVisible] = useState(false)
    const [otoboDialogVisible, setOtoboDialogVisible] = useState(false)
    const [dests, setDests] = useState(props.dests);

    const [datiDottorando, setDatiDottorando] = useState(useStore.getState().datiDottorando);


    //variabile per identificare il caricamento in corso e mostrare spinner
    const [loading, setLoading] = useState(false);



    //elenco soli canali liveHelp
    const [liveHelpMenu, setLiveHelpMenu] = useState(getLiveHelpList())

    //elenco soli canali liveHelp
    const [otoboMenu, setOtoboMenu] = useState(getOtoboList())


    //Gestione asincrona per migliorare il recupero dei dati XXX
    const [labelContent, setLabelContent] = useState(null);


    //elenco soli canali sidera
    const [sideraMenu, setSideraMenu] = useState(getSideraList())

    //elenco soli canali chato tutor
    const [tutorMenu, setTutorMenu] = useState([])

    const [liveHelpFault, setLiveHelpFault] = useState(false);

    //flag che serve per chiudere creazione ticket nel caso di festività
    const [otoboEnabled, setOtoboEnabled] = useState(props.otoboEnabled);

    //flag che serve per abilitare il login preventivo all'apertura del ticket
    const [loginEnabled, setLoginEnabled] = useState(props.selectedArgument?.authRequired || (props.dests?.some(item => item.authRequired) ?? false));


    const [chipTemplate, setChipTeamplate] = useState(props.chipTemplate);

    const [queueInfo, setQueueInfo] = useState([])

    const [emailLinkStatus, setEmailLinkStatus] = useState(getText("SEND_AN_EMAIL"))

    const getHeaderTemplate = () => {
        return <div className='surface-card' style={{ height: "0px" }}></div>
    }

    const isTutorServiceOnline = () => {
        return moment().isoWeekday() >= 1 && moment().isoWeekday() <= 5 && moment().hour() >= 13 && moment().hour() <= 19;
    }

    function compareCampus(a, b) {
        if (a.item.ordinal < b.item.ordinal) {
            return -1;
        }
        if (a.item.ordinal > b.item.ordinal) {
            return 1;
        }
        return 0;
    }

    function compareAlpha(a, b) {
        if (a.item.chiave < b.item.chiave) {
            return -1;
        }
        if (a.item.chiave > b.item.chiave) {
            return 1;
        }
        return 0;
    }

    function compareCampus2(a, b) {
        if (a.ordinal < b.ordinal) {
            return -1;
        }
        if (a.ordinal > b.ordinal) {
            return 1;
        }
        return 0;
    }

    function getSideraList() {
        try {
            return isPianoDegliStudiNode() ? props.channels.filter(channel => channel.channel_id == 'SIDERA') : props.channels.filter(channel => channel.channel_id == 'SIDERA').sort(compareCampus2)
        } catch (e) {
            return []
        }
    }

    function getOtoboList() {
        try {
            return props.channels.filter(channel => channel.channel_id == 'OTOBO')
        } catch (e) {
            return []
        }
    }

    function getLiveHelpList() {
        try {
            return props.channels.filter(channel => channel.channel_id == 'LIVEHELP')
        } catch (e) {
            return []
        }
    }


    useEffect(() => {
        recuperaDati()
        setLoading(true)
        if (props.channels != null) {

            const sideraList = getSideraList();
            const livehelpList = getLiveHelpList();
            const tutorList = props.channels.filter(channel => channel.channel_id == 'TUTOR');
            const otoboList = getOtoboList();

            setLiveHelpMenu(livehelpList)
            setSideraMenu(sideraList)
            setOtoboMenu(otoboList)
            if (isTutorServiceOnline()) {
                setTutorMenu(tutorList)
            }

        } else {
            setTutorMenu(null)
            setLiveHelpMenu(null)
            setSideraMenu(null)
            setOtoboMenu(null)
        }
        setLoading(false)
    }, [props.channels]);


    useEffect(() => {
        setDests(props.dests);
        setLoginEnabled(props.dests?.some(item => item.authRequired) ?? false);
        console.log("dati---> ", props.dests)
        console.log("Login Enabled= " + (props.dests?.some(item => item.authRequired) ?? false))
    }, [props.dests, props.selectedFaq]);

 

    

    


    useEffect(() => {
        //console.log(props.otoboEnabled)
        setOtoboEnabled(props.otoboEnabled)
    }, [props.otoboEnabled]);


    useEffect(() => {
        setChipTeamplate(props.chipTemplate)
    }, [props.chipTemplate]);



    const getOtrsLink = (dests) => {

        var url;
        //prima priorità: se sono dentro una faq su cui ho cliccato (anche da ricerca)
        if (props.idParent != null) {

            props.onExternalJump("M")
            url = "https://onlineservices.polimi.it/configuratorefaq/configuratorefaq/controller/render_secure/Polimi.do?evn_ask=evento&selectedNodeId=" + props.idParent.idArgomento + "&selectedLinkPath=" + props.idParent.idTematica + "&lang=" + language
            //seconda priorità: se ho selezionato tematica e argomento
        } else if (props.selectedArgument != null && props.selectedMenu != null) {
            //devo comunque accertarmi che esista la bustina sull'argomento

            if (dests.length > 0) {


                //console.log("2")
                props.onExternalJump("M")
                var submenu = props.selectedArgument.idNode
                var menu = props.selectedMenu.idNode
                url = "https://onlineservices.polimi.it/configuratorefaq/configuratorefaq/controller/render_secure/Polimi.do?evn_ask=evento&selectedNodeId=" + submenu + "&selectedLinkPath=" + menu + "&lang=" + language
            }

            //terza priorità: se ho selezionato tematica e argomento ma sto cercando la faq e non la trovo devo poter atterrare su ultimo arg selezionato
        } else if (props.previousArgument != null && props.previousMenu != null) {
            props.onExternalJump("M")
            var submenu = props.previousArgument.elemento_id
            var menu = props.previousMenu.elemento_id
            url = "https://onlineservices.polimi.it/configuratorefaq/configuratorefaq/controller/render_secure/Polimi.do?evn_ask=evento&selectedNodeId=" + submenu + "&selectedLinkPath=" + menu + "&lang=" + language

        }
        console.log("getOtrsLink", url)
        return url;
    }

    const openLinkQuestionario = () => {
        setLoading(true)
        PJAxios().get('/chatbot/getUrlSalto/1453').then((res) => {
            var tampering = Buffer.from(sha256("-" + props.conversationId + "-ch9753SSdf0")).toString('base64')
            if (tampering.endsWith("==")) {
                tampering = tampering.replace("==", "");
            }
            var url = res.data + "&spazio=-&conversazione=" + props.conversationId + "&turno=-&tampering=" + tampering;

            window.open(url, '_blank', 'noreferrer')
            setLoading(false)
        })
    }

    //HARDCODED
    const isPianoDegliStudiNode = () => {
        return (props.selectedArgument != null && props.selectedArgument.elemento_id == 302) || (props.idParent != null && props.idParent.idArgomento == 302);
    }


    const op = useRef(null);
    const sOp = useRef(null);

    const getChatQueueInfo = () => {

        let faults = 0;

        let items = [];
        liveHelpMenu.forEach((item) => {
            axios.get(process.env.REACT_APP_LIVEHELP_CHECK_URL + item.valore)
                .then(function (response) {
                    //console.log(response)
                    if (response.data == "-1") {
                        faults = faults + 1;
                        if (faults == liveHelpMenu.length) {
                            setLiveHelpFault(true)
                            setDialogVisible(true)
                        }
                    } else {
                        const splitted = response.data.split(";");
                        items.push({
                            item: item,
                            operatoriAttivi: splitted[0],
                            utentiInCoda: splitted[1],
                            postiDisponibili: splitted[2]
                        })

                        if (splitted[0] == 0) {
                            faults = faults + 1;
                            if (faults == liveHelpMenu.length) {
                                setLiveHelpFault(true)
                                setDialogVisible(true)
                            }
                        }

                        setQueueInfo(items)
                        if (items.length == liveHelpMenu.length) {
                            if (isPianoDegliStudiNode()) {
                                setQueueInfo(items.sort(compareAlpha))
                            } else {
                                setQueueInfo(items.sort(compareCampus))
                            }

                            setDialogVisible(true)
                        }
                    }

                })
                .catch(function (error) {
                    //console.log(error);
                })
        })
    }

    const openSideraLink = (item) => {
        props.onExternalJump("A")
        const splitted = item.split(":");

        const idCoda = splitted[0];
        const codSede = splitted[1];

        //let url = process.env.REACT_APP_SIDERA_JUMP_URL;

        PJAxios().get('/chatbot/getUrlSalto/1691').then((res) => {
            let url = res.data + "&id_coda=::idCoda::&cod_sede=::codSede::"
            url = url.replace("::idCoda::", idCoda)
            url = url.replace("::codSede::", codSede)
            window.open(url, '_blank', 'noreferrer')
        })
    }

    const openLink = (link) => {
        props.onExternalJump("M")
        window.open(link, '_blank', 'noreferrer')
    }

    const openLivehelpQueueCalendarLink = () => {
        window.open(process.env.REACT_APP_LIVEHELP_QUEUE_CALENDAR + "&lang=" + language, '_blank', 'noreferrer')
    }

    const openLivehelpLink = (queueItem) => {
        props.onExternalJump("O")
        window.open(process.env.REACT_APP_LIVEHELP_JUMP_URL + queueItem.item.valore + "&lang=" + language, '_blank', 'noreferrer')
    }

    const openLivehelpLinkByValue = (valore) => {
        props.onExternalJump("W")
        window.open(process.env.REACT_APP_LIVEHELP_JUMP_URL + valore + "&lang=" + language, '_blank', 'noreferrer')
    }

    const openLinkByValue = (valore) => {
        props.onExternalJump("W")
        window.open(valore + "&lang=" + language, '_blank', 'noreferrer')
    }

    const LiveHelpWidget = () => {
        useEffect(() => {
            const loadWidgetScript = () => {
                // Check if the script is already loaded
                if (!document.querySelector(`script[src="//server.livehelp.it/widgetjs/76471/3417.js"]`)) {
                    const lh = document.createElement("script");
                    lh.type = "text/javascript";
                    lh.async = true;
                    lh.src = "//server.livehelp.it/widgetjs/76471/3417.js?x=" + 1 * new Date();
                    lh.onload = () => {

                        if (window.LiveHelp && window.LiveHelp.init) {
                            window.LiveHelp.init();
                        }
                    };
                    document.body.appendChild(lh);
                }
            };

            loadWidgetScript();

            return () => {
                const script = document.querySelector(`script[src="//server.livehelp.it/widgetjs/76471/3417.js"]`);
                if (script) {
                    document.body.removeChild(script);
                }
            };
        }, []);

        return <div id="live-help-widget-container">
            <h1>Wid</h1>
        </div>;
    };

    const getInfoMessage = () => {
        var title = getText("TAG_UTC");
        title = "UTC+1/UTC+2"
        return (<div className='pj-text-secondary-accent-dark'>
            <p>{title}</p>
        </div>);
    }

    //funzione che crea la stringa con la sola iniziale maiuscola
    function capitalizeFirstLetter(input) {
        if (!input) return '';
        const lower = input.toLowerCase();
        return lower.charAt(0).toUpperCase() + lower.slice(1);
    }

    //funzione Per il Login e SessionStorage
    function loginSuccess() {
        if (!isLogged) {
            const afterApp = getAfterApp();
            // 🔹 salvo l'URL corrente (es. /faq/123) nello storage
            sessionStorage.setItem("postLoginRedirect", afterApp);
            sessionStorage.setItem("selectedMenu", JSON.stringify(props.selectedMenu));
            sessionStorage.setItem("selectedArgument", JSON.stringify(props.selectedArgument));

            console.log("---BEFORE SENDLOGIN--- ", props.idConfig);

            sessionStorage.setItem("idConfig", props.idConfig);

            sendLogin();

        } else {
            console.warn("Utente loggato " + isLogged);
            // qui eventualmente puoi aggiungere altro comportamento
        }
    }

    function recuperaDati() {
        let status = getText("SEND_AN_EMAIL");

        if (loading) {
            status = "Caricamento...";
        } else {
            if (loginNeeded) {
                status = "Effettua Login";
            }
        }

        console.log("useStore.getState().datiDottorando", useStore.getState().datiDottorando, "isLogged", isLogged, "props.idConfig", props.idConfig);

        if (useStore.getState().datiDottorando == null && isLogged && props.idConfig == 120) {
            var url = '/dottorando/getDatiDottorando';
            PJAxios().get(url).then((res) => {
                useStore.getState().setDatiDottorando(res.data);
                console.log("Dati dottorando recuperati:", res.data);
                setDatiDottorando(res.data);
            }).catch((err) => console.error(err)).finally(() => setLoading(false));
            status = "Recupero dati...";
        }
        setEmailLinkStatus(status)
    }

    useEffect(() => {
        console.log("loginEnabled", loginEnabled)
        recuperaDati();
    }, [isLogged, loginEnabled, useStore.getState().datiDottorando]);

    function getAfterApp() {
        const url = new URL(window.location.href);
        const path = url.pathname;
        const search = url.search;

        const appIndex = path.indexOf("/app");
        if (appIndex === -1) return "";
        // prendi tutto quello che viene dopo "/app"

        let ret = path.substring(appIndex + 4) + search;;
        console.log("getAfterApp", ret);
        return ret;
    }

    const handleButtonClick = (coda) => {
        // Check if the script is already loaded
        setLoading(true)
        if (!document.querySelector(`script[src="//server.livehelp.it/widgetjs/76471/3417.js"]`)) {

            let lh = document.createElement("script");
            lh.type = "text/javascript";
            lh.async = true;
            lh.src = "//server.livehelp.it/widgetjs/76471/3417.js?x=" + 1 * new Date();
            lh.onload = () => {

                if (window.LiveHelp && window.LiveHelp.init) {
                    window.LiveHelp.init();

                }
                window.LHcoda = coda;
                //console.log(window.LHcoda);
                window.LH_chat();

            };

            document.body.appendChild(lh);
        }
        setLoading(false)

    };

    useEffect(() => {
        return () => {
            const scripts = document.querySelectorAll(`script[src="//server.livehelp.it/widgetjs/76471/3417.js"]`);
            scripts.forEach(script => script.parentNode.removeChild(script));
        };
    }, []);

    const handleOpenTicket = () => {
        //se albero 48 manteniammo il vecchio comportamento
        if (props.idConfig === 48) {
            window.open(getOtrsLink(dests), '_blank', 'noreferrer')
        }
        else {
            useStore.getState().setDests(dests);
            history.push('/dottorandiForm');
        }

    }

    const isDottorando = useMemo(() => {
        const stato = useStore.getState(); // Leggi lo stato all'interno della funzione
        console.log("isDottorando", stato.datiDottorando != null, stato.datiDottorando != null && stato.datiDottorando.isDottorando, props.idConfig == 120);
        return stato.datiDottorando != null && stato.datiDottorando.isDottorando && props.idConfig == 120;
    }, [useStore.getState().datiDottorando, props.idConfig]); // Qui dovresti mettere la parte dello stato che triggera l'aggiornamento

    const loginNeeded = useMemo(() => {

        return loginEnabled && !isLogged;
    }, [loginEnabled, isLogged]); // Qui dovresti mettere la parte dello stato che triggera l'aggiornamento


    return (
        <>
            {loading &&
                <ProgressSpinner />
            }
            {!loading &&
                <div className="surface-hover col-12 md:col-12" style={{ padding: "2px", textAlign: "left", height: "30%" }}>
                    {/* gestione delle eccezioni: 
                piano degli studi (messo su db faq_item_channels)
                international, studenti con titolo estero: gestiscono appuntamenti via OTOBO
                */}
                    {props.externalSources != null && props.externalSources.length > 0 &&
                        <div className=" col-12 md:col-12 lg:col-12">
                            <div className=" col-12 md:col-12 lg:col-12" style={{ padding: "2px" }}>
                                <>
                                    <PJButton style={{ textAlign: "left" }}
                                        icon={`pmi-line pmi-line-link-h pj-text-secondary-accent-dark pmi-32 pj-px-1 no-bg`}
                                        onClick={() => openLinkByValue(props.externalSources[0].EXT_SOURCE)} className="p-button-text"
                                        label={<div className='pj-text-primary-accent-light'> {getText("SITO_INFORMATIVO")}</div>} />
                                </>

                            </div>
                        </div>
                    }



                    {otoboMenu == null || otoboMenu.length <= 1 &&
                        <>
                            {getOtrsLink(dests) != null && //dests.length > 0 &&
                                <div className=" col-12 md:col-12 lg:col-12" style={{ textAlign: 'left', paddingTop: "10px", paddingBottom: "10px" }}>
                                    <p style={{ fontSize: '1.2rem', fontWeight: "bold" }}>
                                        {capitalizeFirstLetter(getText("ANSWER_NOT_FOUND"))}
                                    </p>
                                    {(!loginEnabled || loginNeeded || (isDottorando && props.idConfig == 120)) &&
                                        <>
                                            <p style={{ paddingTop: "1.2em", fontWeight: "bold" }}>
                                                {getText("CONTACT_US")}
                                            </p>

                                            <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>

                                                <>
                                                    <PJButton style={{ textAlign: "left", height: "auto" }}
                                                        icon={`pmi-line ${otoboEnabled ? "pmi-line-circle pj-text-success no-bg " : "pmi-line-circle pj-text-error no-bg"}`}
                                                        iconPos='left'
                                                        disabled={!otoboEnabled}
                                                        onClick={() => loginNeeded ? loginSuccess()
                                                            : handleOpenTicket()}
                                                        className="p-button-text"
                                                        label={
                                                            <div className="pj-text-primary-accent-light">{emailLinkStatus}</div>
                                                        } />


                                                    <div style={{ paddingLeft: "33px" }}>
                                                        <h6>{loginNeeded ? <div>{getText("LOGIN_NEEDED")}</div>
                                                            : getText("SEND_AN_EMAIL_ORARIO_1")}</h6>
                                                    </div>
                                                </>

                                            </div>
                                        </>
                                    }
                                </div>
                            }
                            {false && getOtrsLink(dests) != null && !otoboEnabled && (
                                <Chip className='bg-primary-reverse' template={chipTemplate} />
                            )}
                        </>
                    }

                    {otoboMenu != null && otoboMenu.length > 0 &&
                        <div className=" col-12 md:col-12 lg:col-12" >
                            <div className=" col-12 md:col-12 lg:col-12" style={{ padding: "2px" }}>
                                <Dialog position='bottom' style={{ width: "100%" }} header={getText("CHOOSE_A_CAMPUS")} visible={otoboDialogVisible} ref={sOp} onHide={() => setOtoboDialogVisible(false)}>
                                    <div className="formgroup-inline">
                                        {otoboMenu.map((item) =>
                                            <div key={item.chiave} className='col-6  '>
                                                <PJButton iconPos='left' text style={{ textAlign: "left" }} onClick={() => openLink(item.valore)} className=" p-button-outlined p-button-primary p-button-rounded" label={getText(item.chiave)} />
                                            </div>
                                        )}
                                    </div>
                                </Dialog>
                                <div>
                                    {(!loginEnabled || loginNeeded || (isDottorando && props.idConfig == 120)) && <>
                                        <PJButton iconPos='left' icon={`pmi-line ${otoboMenu ? "pmi-line-circle pj-text-success no-bg " : "pmi-line-circle pj-text-error no-bg"}`}

                                            onClick={
                                                (event) => {
                                                    if (otoboMenu.length == 1) {
                                                        openLink(otoboMenu[0].valore + "&lang=" + language);
                                                    } else {
                                                        setOtoboDialogVisible(true)
                                                    }
                                                }}
                                            className="p-button-text"
                                            style={{ textAlign: "left" }}
                                            label={<div className='pj-text-primary-accent-light'>{otoboMenu.length == 1 ? getText(otoboMenu[0].chiave) : getText("SEND_AN_EMAIL")}</div>} />
                                    </>}
                                    {otoboMenu.length == 1 && <div style={{ padding: "4%" }}>
                                        <Chip style={{ width: "auto" }} className="no-bg" icon="pmi-line pmi-16 pmi-line-location-point pj-text-secondary-accent-dark" label={getInfoMessage()} />
                                    </div>
                                    }
                                    {otoboMenu.length != 1 &&
                                        <div style={{ paddingLeft: "33px" }}>
                                            <h6>{getText("SEND_AN_EMAIL_ORARIO_1")}</h6>
                                        </div>
                                    }
                                </div>
                            </div>

                        </div>
                    }
                    {loginEnabled && (useStore.getState().datiDottorando == null || !useStore.getState().datiDottorando.isDottorando) && props.idConfig == 120 &&
                        <div className=" col-12 md:col-12 lg:col-12" style={{ textAlign: 'left', paddingTop: "10px", paddingBottom: "10px" }}>
                            <h6>{getText("SEND_TICKET_ALLOWED_ONLY_TO_PHD")}</h6>
                        </div>
                    }

                    {props.channels != null &&
                        <>
                            {liveHelpMenu != null && liveHelpMenu.length > 0 &&
                                <div className=" col-12 md:col-12 lg:col-12" style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                                    <div className=" col-12 md:col-12 lg:col-12" style={{ padding: "0px" }}>
                                        <>
                                            <Dialog position='bottom' style={{ width: "100%" }} headerTemplate={getHeaderTemplate} header={getText("CHOOSE_A_CAMPUS")} visible={dialogVisible} ref={op} onHide={() => setDialogVisible(false)}>
                                                {liveHelpFault &&
                                                    <>
                                                        <div className=" col-12 md:col-12 lg:col-12" style={{ textAlign: 'left' }}>
                                                            {getText("NO_OPERATORS_AVAILABLE")}
                                                        </div>
                                                        <div className=" col-12 md:col-12 lg:col-12" style={{ textAlign: 'left' }}>
                                                            <PJButton iconPos='left'
                                                                className="p-button-text"
                                                                icon={`pmi-line ${liveHelpFault !== null ? "pmi-line-circle pj-text-success no-bg " : "pmi-line-circle pj-text-error no-bg"}`}
                                                                style={{ textDecorationLine: 'underline', textTransform: "uppercase", textAlign: "left" }}
                                                                onClick={() => openLivehelpQueueCalendarLink()} label={getText("LIVEHELP_CHAT_CALENDAR")} />

                                                        </div>
                                                    </>
                                                }
                                                <div className="formgroup-inline">

                                                    {queueInfo.map((queueItem) =>
                                                        <div key={queueItem.item.chiave} className='formgroup-inline col-12'>

                                                            {queueItem.operatoriAttivi == 0 &&
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td><i style={{ height: "16px", width: "16px", verticalAlign: "middle" }} className='pi pi-times-circle' ></i></td>
                                                                            <td><PJButton iconPos='left'
                                                                                className="p-button-text"
                                                                                style={{ textDecorationLine: 'underline', textTransform: "uppercase" }}
                                                                                disabled onClick={() => openLivehelpLink(queueItem)} label={getText(queueItem.item.chiave)} /></td>
                                                                            <td>{getText("CHAT_NOT_AVAILABLE")}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            }
                                                            {queueItem.operatoriAttivi > 0 && (Number(queueItem.utentiInCoda) >= Number(queueItem.postiDisponibili)) &&
                                                                <table>
                                                                    <tr>
                                                                        <td><i className='pi pi-circle-fill' /></td>
                                                                        <td><PJButton iconPos='left' className="p-button-text"
                                                                            style={{ textDecorationLine: 'underline', textTransform: "uppercase" }}
                                                                            disabled onClick={() => window.open(process.env.REACT_APP_LIVEHELP_JUMP_URL + queueItem.item.valore + "&lang=" + language, '_blank', 'noreferrer')} label={getText(queueItem.item.chiave)} />
                                                                        </td>
                                                                        <td><i className='pi pi-users'></i></td>
                                                                        <td>
                                                                            {queueItem.postiDisponibili + " max /" + queueItem.utentiInCoda + " " + getText("ON_QUEUE")}
                                                                        </td>

                                                                    </tr>
                                                                </table>
                                                            }

                                                            {queueItem.operatoriAttivi > 0 && (Number(queueItem.utentiInCoda) < Number(queueItem.postiDisponibili)) &&
                                                                <table>
                                                                    <tr>
                                                                        <td><i className='pi pi-chevron-circle-down' /></td>
                                                                        <td><PJButton iconPos='left' icon="" className="p-button-text"
                                                                            style={{ textDecorationLine: 'underline', textTransform: "uppercase" }}
                                                                            onClick={() => handleButtonClick(queueItem.item.valore)} label={getText(queueItem.item.chiave)} />

                                                                        </td>
                                                                        <td><i className='pi pi-users'></i></td>
                                                                        <td>
                                                                            {queueItem.postiDisponibili + " max /" + queueItem.utentiInCoda + " " + getText("ON_QUEUE")}
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            }
                                                        </div>
                                                    )}
                                                </div>
                                            </Dialog>

                                            <PJButton iconPos='left' onClick={() => getChatQueueInfo()}
                                                style={{ height: "auto" }}
                                                className="p-button-text"
                                                icon={`pmi-line ${!liveHelpMenu != null && liveHelpMenu.length > 0 ? "pmi-line-circle pj-text-success no-bg " : "pmi-line-circle pj-text-error no-bg"}`}
                                                label={<div className='pj-text-primary-accent-light'>{getText("CHAT_WITH_AN_OPERATOR")}</div>} />
                                            <div style={{ paddingLeft: "33px", paddingTop: "0px" }}>
                                                {props.selectedArgument?.idNode === 2206 || props.selectedArgument?.idNode === 2703 ? (
                                                    <>
                                                        <h6>{getText("CHAT_WITH_AN_OPERATOR_ORARIO_INTERNATIONAL")}</h6>
                                                        <h6>{getText("CHAT_WITH_AN_OPERATOR_ORARIO_INTERNATIONAL2")}</h6>
                                                    </>
                                                ) : (
                                                    <>
                                                        <h6>{getText("CHAT_WITH_AN_OPERATOR_ORARIO")}</h6>
                                                        <h6>{getText("CHAT_WITH_AN_OPERATOR_ORARIO2")}</h6>
                                                    </>
                                                )}
                                            </div>

                                        </>

                                    </div>
                                </div>

                            }

                            {tutorMenu != null && tutorMenu.length > 0 &&
                                <div className=" col-12 md:col-12 lg:col-12" style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                                    <div className=" col-12 md:col-12 lg:col-12" style={{ padding: "0px" }}>
                                        <>
                                            <PJButton iconPos='left' text style={{ height: "auto", textAlign: "left" }} icon={`pmi-line ${tutorMenu != null && tutorMenu.length > 0 ? "pmi-line-circle pj-text-success no-bg " : "pmi-line-circle pj-text-error no-bg"}`}
                                                onClick={() => handleButtonClick(tutorMenu[0].valore)}
                                                className="p-button-text"
                                                label={<div className='pj-text-primary-accent-light'> {getText("CHAT_WITH_A_TUTOR")}</div>} />
                                            <div style={{ paddingLeft: "33px" }}>
                                                <h6>{getText("CHAT_WITH_A_TUTOR_ORARIO")}</h6>
                                            </div>

                                        </>

                                    </div>
                                </div>

                            }

                            {sideraMenu != null && sideraMenu.length > 0 &&
                                <div className=" col-12 md:col-12 lg:col-12" style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                                    <div className=" col-12 md:col-12 lg:col-12" style={{ padding: "0px" }}>
                                        {sideraMenu != null &&
                                            <>
                                                <Dialog position='bottom' style={{ width: "100%" }} header={getText("CHOOSE_A_CAMPUS")} visible={sideraDialogVisible} ref={sOp} onHide={() => setSideraDialogVisible(false)}>
                                                    <div className="formgroup-inline">
                                                        {sideraMenu.map((item) =>
                                                            <div key={item.chiave} className='col-6  '>
                                                                <PJButton iconPos='left' onClick={() => openSideraLink(item.valore)} className=" p-button-outlined p-button-primary p-button-rounded" label={getText(item.chiave)} />
                                                            </div>
                                                        )}
                                                    </div>
                                                </Dialog>
                                                <PJButton iconPos='left'
                                                    style={{ height: "auto", paddingTop: "10px", paddingBottom: "10px" }}
                                                    icon={`pmi-line ${!sideraMenu != null ? "pmi-line-circle pj-text-success no-bg " : "pmi-line-circle pj-text-error no-bg"}`}
                                                    onClick={
                                                        (event) => {
                                                            if (sideraMenu.length == 1) {
                                                                openSideraLink(sideraMenu[0].valore);
                                                            } else {
                                                                setSideraDialogVisible(true)
                                                            }
                                                        }}
                                                    className="p-button-text"
                                                    label={<div className='pj-text-primary-accent-light'>{getText("TAKE_AN_APPOINTMENT")}</div>} />
                                                <div style={{ paddingLeft: "0px", paddingTop: "6%" }}>
                                                    <Chip style={{ width: "auto" }} className="no-bg" icon="pmi-line pmi-16 pmi-line-location-point pj-text-secondary-accent-dark" label={getInfoMessage()} />
                                                </div>


                                            </>

                                        }


                                    </div>
                                </div>
                            }
                        </>
                    }



                </div >
            }
        </>
    )
}

export default ContactChannels
